/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from 'moment';
import React from 'react';

export type SummaryCardProps = {
  heading?: React.ReactNode;
  data?: any[];
  description?: React.ReactNode;
  icon?: React.ReactNode;
  mode?: 'tooltip' | 'normal';
};

export const DataRow = ({ data }) => {
  const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
  const processValue = (value: any) => {
    // Handle Date Values: Format date values using parseDate function
    if (typeof value === 'string' && moment(value, true).isValid()) {
      return moment(value).format('lll'); // parseDate is a function to format dates
    }

    // Handle URL Values
    if (typeof value === 'string' && urlRegex.test(value)) {
      return (
        <a href={value} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
      ); // Open link in new tab
    }

    return value?.toString();
  };

  return (
    <div className="row row-cols-auto">
      {data.map((item, index) =>
        item?.value !== undefined ? (
          <div key={`item_${index}`} className="col-auto">
            <p>
              <strong>{item.key}: </strong>
              <span>{processValue(item.value)}</span>
            </p>
          </div>
        ) : null,
      )}
      <div className="col"></div>
    </div>
  );
};

const SummaryCard = ({
  heading,
  data,
  description,
  icon,
}: SummaryCardProps) => {
  const _smSizeStyle = { maxWidth: '400px' };
  return (
    <div className="row p-2">
      <div
        className="col-auto d-flex justify-content-center align-items-top p-3"
        style={{ backgroundColor: '#f7f8f9' }}
      >
        {icon ? (
          icon
        ) : (
          <i
            className="fa fa-info-circle"
            aria-hidden="true"
            style={{ fontSize: '3rem' }}
          ></i>
        )}
      </div>
      <div className="col p-2">
        {heading && (
          <div className="row">
            <div className="col">
              <h4 className="card-title">{heading}</h4>
            </div>
          </div>
        )}
        <DataRow data={data} />
        {description && (
          <div className="mt-3">
            <p className="card-text">{description}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SummaryCard;
